<template>
  <div class="addEmployee">
    <div class="top"></div>
    <div class="content">
      <div class="title">基本信息
        <!-- （必填） -->
        </div>
      <div class="cont">
        <span>员工姓名</span>
        <input type="text" placeholder="请输入员工姓名" v-model="subData.realname">
      </div>
      <div class="cont">
        <span>联系方式</span>
        <input type="number" placeholder="请输入员工电话" v-model="subData.mobile">
      </div>
      <div class="title">功能权限</div>
      <div class="cont">
        <span>员工角色</span>
        <span>
          <van-radio-group v-model="subData.role_type" label-position="left">
            <!-- <van-radio name="1" checked-color="#31B158" label-position="left">老板（超级管理员）</van-radio> -->
            <van-radio v-for="(item,i) in list" :key="i" :name="item.id" checked-color="#31B158" label-position="left">{{item.name}}</van-radio>
          </van-radio-group>
        </span>
      </div>
      <div class="bottom" @click="save">保存</div>
    </div>
  </div>
</template>

<script>
import { isEmpty, isMobile  } from "@/utils/validate";
import { employee_create ,employee_role_list} from "@/api/work/mine/employee";
export default {
  name: 'addEmployee',
  data(){
    return {
      radio:'1',
      subData:{
        realname:'',
        mobile:'',
        role_type:'2'
      },
      list:[]
    }
  },
  created(){
    // if(this.$route.query.id){
    //   this.$route.meta.title = '编辑员工'
    // }else{
    //   this.$route.meta.title = '添加员工'
    // }
    this.getList()
  },
  mounted(){

  },
  methods:{
    // 保存数据
    save(){
      if(!this.subData.realname){ this.$toast("请输入员工名字！"); return false }
      if(!isMobile(this.subData.mobile)){ this.$toast("请输入正确的手机号码！"); return false }
      if(!this.subData.role_type){ this.$toast("请选择员工角色！"); return false }
      employee_create(this.subData).then(res=>{
        this.$toast.success(res.message)
        this.$router.go(-1)
      })
    },
    //店铺角色list
     getList() {
      employee_role_list().then(res => {
        if (res.code == 200) {
          this.list = res.data;
        }
      });
    },
  }
}
</script>

<style lang="less" scoped>
  .addEmployee{
    .top{
      width: 100%;
      height: 3.6rem;
      background: url("../../../../assets/img/work/manage/buyer_bg.png") no-repeat center;
      background-size: 100% 100%;
    }
    .content{
      width: 6.5rem;
      margin: -1.8rem auto 0.78rem;
      background-color: #fff;
      padding: 0 0.3rem 0.3rem;
      border-radius: 0.16rem;
      overflow: hidden;
      .title{
        color: #727272;
        font-size: 0.24rem;
        margin-top: 0.44rem;
        margin-bottom: 0.09rem;
      }
      .cont{
        color: #343434;
        font-size: 0.28rem;
        border-bottom: #E8E8E8 solid 0.01rem;
        margin-top: 0.4rem;
        padding-bottom: 0.19rem;
        display: flex;
        >span:first-child{
          width: 2.24rem;
          vertical-align: top;
        }
        >span:last-child{
          flex-grow: 1;
          .van-radio{
            justify-content: space-between;
            line-height: 0.51rem;
          }
          .van-radio{
            margin-bottom: 0.2rem;
          }
        }
      }
      .text{
        margin: 0.2rem auto 1.07rem;
        >div{
          width: 6.49rem;
          height: 3.26rem;
          border: 0.01rem #E4E4E4 solid;
        }
      }
      .bottom{
        width: 6.5rem;
        line-height: 1rem;
        background-color: #31b158;
        text-align: center;
        color: #fff;
        border-radius: 0.08rem;
        margin-top: 0.8rem;
      }
    }
  }
</style>